import BaseCollection from "lib/collection";
import Replenishment from "models/replenishment";

export default BaseCollection.extend({
    model: Replenishment,
    url() {
        if (this.parent.id && this.parent.collection.parent._id) {
            return `/api/v3.0/item/${this.parent.collection.parent._id}/warehouse/${this.parent.id}/replenishments`;
        }
        throw Error("Must have parent id");
    },

    fetch(options = {}) {
        if (!this.fetching) {
            this.fetching = true;

            const success = options.success;
            options.success = (model, data, optionsObj) => {
                this.fetching = false;
                if (success) {
                    success(model, data, optionsObj);
                }
            };

            const error = options.error;
            options.error = (model, response, optionsObj) => {
                this.fetching = false;
                if (!optionsObj.xhr.aborted) {
                    if (error) {
                        error(model, response, optionsObj);
                    }
                }
            };

            BaseCollection.prototype.fetch.call(this, options);
        }
    },
});
